import { ContentWrapper } from "../../components/ContentWrapper/ContentWrapper";
import { AppContext } from "../../components/Menu/MenuButton";
import { PageTabPanel } from "../../components/PageTabPanel/PageTabPanel";
import { ActionsContext, ActionsRoutes } from "./ACtionsRoutes";

const ACTIONS_TABS = [{
    name: 'Задания',
    context: `/${AppContext.Actions}/${ActionsContext.Tasks}`,
}, {
    name: 'Мини-игры',
    context: `/${AppContext.Actions}/${ActionsContext.Games}`,
}];

export const ActionsPage = () => {
    return (
        <ContentWrapper noTopPadding={ true }>
            <PageTabPanel tabs={ ACTIONS_TABS }/>
            <ActionsRoutes />
        </ContentWrapper>
    );
};
